/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from './ErrorBoundary';
import SlotEditorView from './SlotEditorView';

/**
 * The SlotEditor component is responsible for editing of the slots/filters for the widget whose api is provided.
 */
class SlotEditor extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			slotEditorModel,
			dndManager,
			logger,
			extensions
		} = this.props;
		return (
			<ErrorBoundary
				logger={logger}
			>
				<SlotEditorView
					dndManager={dndManager}
					slotEditorModel={slotEditorModel}
					extensions={extensions}
				/>
			</ErrorBoundary>
		);
	}
}

SlotEditor.propTypes = {
	dndManager: PropTypes.object.isRequired,
	slotEditorModel: PropTypes.object.isRequired,
	logger: PropTypes.object.isRequired,
	extensions: PropTypes.array
};

export default SlotEditor;



// WEBPACK FOOTER //
// ./src/js/SlotEditor.js